// Servicio ventas - Sprint 32.
import apiClient from '../../../api/apiClient';

const BASE = '/ventas';

export async function listVentas({ page = 1, per_page = 25, q = '', estado = '' } = {}) {
  const params = new URLSearchParams();
  params.set('page', page); params.set('per_page', per_page);
  if (q) params.set('q', q);
  if (estado) params.set('estado', estado);
  const r = await apiClient.get(BASE + '/?' + params.toString());
  const d = (r && r.data) || {};
  return { items: d.items || [], total: d.total || 0 };
}

export async function getVenta(id) {
  const r = await apiClient.get(BASE + '/' + id);
  return (r && r.data) || null;
}

export async function nextNumero() {
  const r = await apiClient.get(BASE + '/next-number');
  return (r && r.data && r.data.numero) || '';
}

export async function createVenta(payload) {
  const r = await apiClient.post(BASE + '/', payload);
  return (r && r.data) || null;
}

export async function updateVenta(id, payload) {
  const r = await apiClient.put(BASE + '/' + id, payload);
  return (r && r.data) || null;
}

export async function deleteVenta(id) {
  return apiClient.delete(BASE + '/' + id);
}

export async function emitir(id) {
  const r = await apiClient.post(BASE + '/' + id + '/emitir', {});
  return (r && r.data) || null;
}

export async function anular(id) {
  const r = await apiClient.post(BASE + '/' + id + '/anular', {});
  return (r && r.data) || null;
}

// Lineas
export async function listLineas(id) {
  const r = await apiClient.get(BASE + '/' + id + '/lineas');
  return (r && r.data && r.data.items) || [];
}

export async function createLinea(id, payload) {
  const r = await apiClient.post(BASE + '/' + id + '/lineas', payload);
  return (r && r.data) || null;
}

export async function updateLinea(lid, payload) {
  const r = await apiClient.put(BASE + '/lineas/' + lid, payload);
  return (r && r.data) || null;
}

export async function deleteLinea(lid) {
  return apiClient.delete(BASE + '/lineas/' + lid);
}

export async function recalcVenta(id) {
  const r = await apiClient.post('/ventas/' + id + '/recalc', {});
  return (r && r.data) || null;
}
